import React from 'react';
import classnames from 'classnames';

/**
 * Drop-in replacement for CoreUI's <CFade>: fades children in on mount via the
 * `.fade-in` CSS animation (defined in src/styles/global.css — no framer-motion,
 * this project is on React 17). Forwards className/style and a ref to the
 * underlying DOM node (replaces CFade's `innerRef`, used e.g. for scrollTo).
 */
const FadeIn = React.forwardRef(({ children, className, style, ...rest }, ref) => (
  <div ref={ref} className={classnames('fade-in', className)} style={style} {...rest}>
    {children}
  </div>
));

export default FadeIn;
